/**
 * Task Filter Component
 *
 * Horizontal scrollable list of task filter buttons
 */

import React from 'react'
import type { TaskType } from 'src/store/todo/types'
import { getTaskColor } from '../../utils'

type TaskFilterProps = {
  /** Array of all available task types */
  tasks: TaskType[]
  /** Array of currently selected task IDs */
  selectedTasks: string[]
  /** Callback when a task is toggled */
  onToggleTask: (taskId: string) => void
}

/**
 * TaskFilter component for filtering assignments by task type
 *
 * @example
 * <TaskFilter
 *   tasks={allTasks}
 *   selectedTasks={['task-1', 'task-2']}
 *   onToggleTask={handleToggle}
 * />
 */
const TaskFilter: React.FC<TaskFilterProps> = ({ tasks, selectedTasks, onToggleTask }) => {
  if (tasks.length === 0) return null

  return (
    <div className="overflow-x-auto -mx-4 px-4">
      <div className="flex gap-3 flex-nowrap">
        {tasks.map((task: TaskType) => {
          const taskColor = getTaskColor(task.id, tasks)
          const isSelected = selectedTasks.includes(task.id)

          return (
            <button
              key={task.id}
              onClick={() => onToggleTask(task.id)}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors flex-shrink-0 whitespace-nowrap ${
                isSelected
                  ? 'text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
              style={isSelected ? { backgroundColor: taskColor } : {}}
            >
              {task.taskType}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default TaskFilter
